// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { Role } from './Role'
import { RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from './Role'

/**
 *
 * @export
 * @interface SimpleProfileRepresentation
 */
export interface SimpleProfileRepresentation {
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  userId: string
  /**
   *
   * @type {number}
   * @memberof SimpleProfileRepresentation
   */
  blakeId: number
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  schoolId: string
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  username: string
  /**
   *
   * @type {Role}
   * @memberof SimpleProfileRepresentation
   */
  role: Role
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  firstName: string
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  lastName: string
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  dna: string
  /**
   *
   * @type {string}
   * @memberof SimpleProfileRepresentation
   */
  avatar: string
}

/**
 * Check if a given object implements the SimpleProfileRepresentation interface.
 */
export function instanceOfSimpleProfileRepresentation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'userId' in value
  isInstance = isInstance && 'blakeId' in value
  isInstance = isInstance && 'schoolId' in value
  isInstance = isInstance && 'username' in value
  isInstance = isInstance && 'role' in value
  isInstance = isInstance && 'firstName' in value
  isInstance = isInstance && 'lastName' in value
  isInstance = isInstance && 'dna' in value
  isInstance = isInstance && 'avatar' in value

  return isInstance
}

export function SimpleProfileRepresentationFromJSON(
  json: any,
): SimpleProfileRepresentation {
  return SimpleProfileRepresentationFromJSONTyped(json, false)
}

export function SimpleProfileRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SimpleProfileRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userId: json['user_id'],
    blakeId: json['blakeId'],
    schoolId: json['schoolId'],
    username: json['username'],
    role: RoleFromJSON(json['role']),
    firstName: json['first_name'],
    lastName: json['last_name'],
    dna: json['dna'],
    avatar: json['avatar'],
  }
}

export function SimpleProfileRepresentationToJSON(
  value?: SimpleProfileRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    user_id: value.userId,
    blakeId: value.blakeId,
    schoolId: value.schoolId,
    username: value.username,
    role: RoleToJSON(value.role),
    first_name: value.firstName,
    last_name: value.lastName,
    dna: value.dna,
    avatar: value.avatar,
  }
}
